<button class="btn btn-lg btn-primary btn-block text-white" (click)="redirectToExternalProvider()">
  <i class="fas fa-sign-in-alt"></i> {{getButtonLabel() | translate}}
</button>
